import { GoogleMap, Marker } from '@react-google-maps/api';
import React from 'react';

type LatLng = {
    lat: number;
    lng: number;
};

type Props = {
    locations: LatLng[];
};

const Map: React.FC<Props> = ({ locations }) => {
    // const { isLoaded, loadError } = useLoadScript({
    //     googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '', // Replace with your API key
    // });

    // if (loadError) {
    //     return <div>Error loading Google Maps</div>;
    // }

    // if (!isLoaded) {
    //     return <div>Loading Google Maps...</div>;
    // }

    return (
        <GoogleMap
            center={{ lat: 54.7781, lng: -3.436 }}
            mapContainerStyle={{ width: '100%', height: '400px' }}
            options={{
                mapTypeControl: false,
                streetViewControl: false,
            }}
            zoom={5}
        >
            {locations.map((location) => (
                <Marker key={`${location.lat}-${location.lng}`} position={location} />
            ))}
        </GoogleMap>
    );
};

export { Map };
